export function isUserInSupportMode(me: { id: string | number }) {
  return me.id === 0 || me.id === '0';
}
